export enum EntityRoleType {
  DISTRIB = "DISTRIB",
  ASSU = "ASSU",
  ASSI = "ASSI",
  GSINI = "GSINI",
  GCON = "GCON",
  GIT = "GIT",
  GCOUR = "GCOUR",
  MARQ = "MARQ",
  GDEV = "GDEV",
  ASSU_TAX = "ASSU_TAX",
  FIN_PROMO = "FIN_PROMO",
  PARTENAIRE = "PARTENAIRE",
}
